import Swal from "sweetalert2";

window.Swal = Swal;

export { Swal as default };
